import React, { useState } from 'react';
import { notificationsData } from '../data/sampleData';
import { AlertItem } from '../components/AlertItem';
interface NotificationsPageProps {
  t: (key: string) => string;
  navigate: (page: string, id?: string) => void;
}
export function NotificationsPage({
  t,
  navigate
}: NotificationsPageProps) {
  const [filter, setFilter] = useState('all');
  const filteredNotifications = filter === 'all' ? notificationsData : notificationsData.filter(n => n.type === filter);
  const handleNotificationClick = (type: string) => {
    if (type === 'notice' || type === 'mutation') {
      navigate('services');
    } else if (type === 'dispute') {
      navigate('mylands');
    } else if (type === 'verification') {
      navigate('certificate');
    }
  };
  return <div className="max-w-3xl mx-auto space-y-6 pb-20 lg:pb-6" data-id="element-598">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-599">
        <div data-id="element-600">
          <h2 className="text-2xl font-bold text-slate-800" data-id="element-601">
            {t('notifications.title')}
          </h2>
          <p className="text-slate-500" data-id="element-602">{t('notifications.subtitle')}</p>
        </div>
        <button className="text-sm text-[#006A4E] font-medium hover:underline" data-id="element-603">
          {t('notifications.markAllRead')}
        </button>
      </div>

      {/* Filters */}
      <div className="flex overflow-x-auto gap-2 pb-2 scrollbar-hide" data-id="element-604">
        {['all', 'notice', 'mutation', 'dispute', 'verification'].map(type => <button key={type} onClick={() => setFilter(type)} className={`px-4 py-1.5 rounded-full text-sm font-medium capitalize whitespace-nowrap transition-colors ${filter === type ? 'bg-[#006A4E] text-white' : 'bg-white border border-slate-200 text-slate-600 hover:bg-slate-50'}`} data-id="element-605">
              {type === 'all' ? t('common.all') : type}
            </button>)}
      </div>

      {/* List */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-606">
        <div className="divide-y divide-slate-100" data-id="element-607">
          {filteredNotifications.length > 0 ? filteredNotifications.map(notification => <div key={notification.id} className="p-2" data-id="element-608">
                <AlertItem type={notification.type} title={notification.title} message={notification.message} date={notification.date} read={notification.read} onClick={() => handleNotificationClick(notification.type)} data-id="element-609" />
              </div>) : <div className="p-8 text-center text-slate-500" data-id="element-610">
              No notifications found for this category.
            </div>}
        </div>
      </div>
    </div>;
}